import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangeQuestionDisplayComponent } from './components/range-question-display/range-question-display.component';
import { PhoneNumberQuestionDisplayComponent } from './components/phone-number-question-display/phone-number-question-display.component';
import { NumberQuestionDisplayComponent } from './components/number-question-display/number-question-display.component';
import { MultiQuestionDisplayComponent } from './components/multi-question-display/multi-question-display.component';
import { MarkQuestionDisplayComponent } from './components/mark-question-display/mark-question-display.component';
import { FreeTextQuestionDisplayComponent } from './components/free-text-question-display/free-text-question-display.component';
import { AutocompleteQuestionDisplayComponent } from './components/autocomplete-question-display/autocomplete-question-display.component';
import { TableQuestionDisplayComponent } from './components/table-question-display/table-question-display.component';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { DividerLineDisplayComponent } from './components/divider-line-display/divider-line-display.component';
import { FillQuestionDisplayComponent } from './components/fill-question-display/fill-question-display.component';
import { SendButtonDisplayComponent } from './components/send-button-display/send-button-display.component';
import { TextToQuestionDisplayComponent } from './components/text-to-question-display/text-to-question-display.component';
import { TitleQuestionDisplayComponent } from './components/title-question-display/title-question-display.component';
import { LinkDisplayComponent } from './components/link-display/link-display.component';
import { UploadFileDisplayComponent } from './components/upload-file-display/upload-file-display.component';
import { DateQuestionDisplayComponent } from './components/date-question-display/date-question-display.component';
import { QuestionsGroupDisplayComponent } from './components/questions-group-display/questions-group-display.component';
import { SignatureDisplayComponent } from './components/signature-display/signature-display.component';
import { ImageDisplayComponent } from './components/image-display/image-display.component';
import { TextToQuestionComponent } from '../question-form/components/text-to-question/text-to-question.component';
import { UploadFileAdminDisplayComponent } from './components/upload-file-admin-display/upload-file-admin-display.component';
import { ExpenseDisplayComponent } from "./components/expense-display/expense-display.component";

@Component({
    selector: 'que-question-form-display',
    imports: [CommonModule,
        TableQuestionDisplayComponent,
        RangeQuestionDisplayComponent,
        PhoneNumberQuestionDisplayComponent,
        NumberQuestionDisplayComponent,
        MultiQuestionDisplayComponent,
        MarkQuestionDisplayComponent,
        FreeTextQuestionDisplayComponent,
        AutocompleteQuestionDisplayComponent,
        FillQuestionDisplayComponent,
        DividerLineDisplayComponent,
        SendButtonDisplayComponent,
        UploadFileDisplayComponent,
        LinkDisplayComponent,
        TextToQuestionDisplayComponent,
        TextToQuestionComponent,
        DateQuestionDisplayComponent,
        QuestionsGroupDisplayComponent,
        SignatureDisplayComponent,
        ImageDisplayComponent,
        TitleQuestionDisplayComponent,
        UploadFileAdminDisplayComponent, ExpenseDisplayComponent],
    templateUrl: './question-form-display.component.html',
    styleUrls: ['./question-form-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionFormDisplayComponent {
  @Input() question!: Question;
  eQuestionType = EQuestionType;
  @Input() isPreview = false;
  @Input() viewAnswer = false;

}
